import { render } from "./Sustainability.vue?vue&type=template&id=252d856b"
import script from "./Sustainability.vue?vue&type=script&lang=js"
export * from "./Sustainability.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__